import FoodPackageCreate from './FoodPackageCreate'
import FoodPackageEdit from './FoodPackageEdit'
import { buildPackageList } from 'ui-shared/WrappedInputs/Packages/BasePackageList'

const foodPackageIndex = {
  list: buildPackageList('foods'),
  edit: FoodPackageEdit,
  create: FoodPackageCreate,
}

export default foodPackageIndex
